/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { http_BatchStatsRequest } from '../models/http_BatchStatsRequest';
import type { http_BatchStatsResponse } from '../models/http_BatchStatsResponse';
import type { http_UniqueCountriesResponse } from '../models/http_UniqueCountriesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsService {
    /**
     * Get Unique Countries
     * Retrieve all unique countries that have been recorded in visits.
     * @returns http_UniqueCountriesResponse List of unique countries
     * @throws ApiError
     */
    public static getAnalyticsCountries(): CancelablePromise<http_UniqueCountriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/countries',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Batch Visit Statistics
     * Retrieve visit statistics for multiple short IDs in a single request. Returns total count and last visit time for each short ID (country stats currently empty).
     * @param request List of short IDs to get statistics for (max 100)
     * @returns http_BatchStatsResponse Batch visit statistics
     * @throws ApiError
     */
    public static postAnalyticsVisitsStats(
        request: http_BatchStatsRequest,
    ): CancelablePromise<http_BatchStatsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/analytics/visits/stats',
            body: request,
            errors: {
                400: `Validation Error - invalid request body or too many IDs`,
                500: `Internal Server Error`,
            },
        });
    }
}
